var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPartnersMenuIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 18.036,
    height: 15.785,
    viewBox: "0 0 18.036 15.785",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-14633654"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_5256",
    "data-name": "Rectangle 5256",
    width: 18.036,
    height: 15.785,
    fill: "#fff"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_98440",
    "data-name": "Group 98440",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_26980",
    "data-name": "Group 26980",
    transform: "translate(0 0)",
    clipPath: "url(#clip-path-14633654)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_62462",
    "data-name": "Path 62462",
    d: "M17.285,9.771h-.5a3.724,3.724,0,0,0-.56.043L10.929,5.842,12.2,4.628a.752.752,0,1,0-1.04-1.085l-3.136,3a.751.751,0,0,1-1.147-.1.806.806,0,0,1,.126-1l3.535-3.329a2.278,2.278,0,0,1,2.534-.373l1.741.872a3.787,3.787,0,0,0,1.679.4h.795a.752.752,0,1,0,0-1.5H16.49a2.272,2.272,0,0,1-1.008-.238L13.742.4a3.812,3.812,0,0,0-4.24.622l-.463.437L8.515.976A3.786,3.786,0,0,0,4.292.4l-1.739.87a2.274,2.274,0,0,1-1.01.238H.752a.752.752,0,1,0,0,1.5h.795a3.789,3.789,0,0,0,1.679-.4l1.739-.87A2.344,2.344,0,0,1,7.5,2.086l.44.4L5.955,4.361a2.316,2.316,0,0,0-.3,2.959,2.453,2.453,0,0,0,1.837.947,2.239,2.239,0,0,0,1.582-.648L9.829,6.9l4.77,3.576c-.024.017-4.659,3.492-4.659,3.492a1.506,1.506,0,0,1-1.856-.009L3.509,10.522a3.787,3.787,0,0,0-2.257-.752h-.5a.752.752,0,0,0,0,1.5h.5a2.275,2.275,0,0,1,1.355.45L7.171,15.15a3.011,3.011,0,0,0,1.85.635,2.973,2.973,0,0,0,1.831-.628l4.579-3.432a2.259,2.259,0,0,1,1.353-.452h.5a.752.752,0,1,0,0-1.5Z",
    transform: "translate(0 0)",
    fill: "#fff"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPartnersMenuIcon);
export default __webpack_public_path__ + "static/media/partners-menu-icon.c76f28aa3ffc28a95a12f207c12c9536.svg";
export { ForwardRef as ReactComponent };